import { css as u, LitElement as y, html as m, nothing as v } from "lit";
import { property as a, customElement as f } from "lit/decorators.js";
import { classMap as h } from "lit/directives/class-map.js";
import { b as g } from "./styles-scZ6dVz-.js";
var b = Object.defineProperty, x = Object.getOwnPropertyDescriptor, d = (r, e, l, s) => {
  for (var t = s > 1 ? void 0 : s ? x(e, l) : e, p = r.length - 1, c; p >= 0; p--)
    (c = r[p]) && (t = (s ? c(e, l, t) : c(t)) || t);
  return s && t && b(e, l, t), t;
};
let i = class extends y {
  constructor() {
    super(...arguments), this.orientation = "vertical", this.size = "md", this.bordered = !1, this.striped = !1;
  }
  render() {
    const r = !!(this.columns && this.columns > 1), e = {
      list: !0,
      [this.orientation]: !r,
      [this.size]: !0,
      grid: r,
      "cols-2": this.columns === 2,
      "cols-3": this.columns === 3,
      "cols-4": this.columns === 4,
      bordered: this.bordered,
      striped: this.striped
    };
    return m`
      <dl part="list" class=${h(e)}>
        <slot></slot>
      </dl>
    `;
  }
};
i.styles = [
  g,
  u`
      :host {
        display: block;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .list {
        display: flex;
        font-family: var(--r5-font-body);
      }

      /* Vertical layout (stacked) */
      .vertical {
        flex-direction: column;
        gap: var(--r5-space-4);
      }

      /* Horizontal layout (inline) */
      .horizontal {
        flex-direction: row;
        flex-wrap: wrap;
        gap: var(--r5-space-6);
      }

      /* Grid layout */
      .grid {
        display: grid;
        gap: var(--r5-space-4);
      }

      .grid.cols-2 {
        grid-template-columns: repeat(2, 1fr);
      }

      .grid.cols-3 {
        grid-template-columns: repeat(3, 1fr);
      }

      .grid.cols-4 {
        grid-template-columns: repeat(4, 1fr);
      }

      /* Sizes */
      .sm {
        --data-list-label-size: var(--r5-text-xs);
        --data-list-value-size: var(--r5-text-sm);
        --data-list-gap: var(--r5-space-0-5);
      }

      .md {
        --data-list-label-size: var(--r5-text-sm);
        --data-list-value-size: var(--r5-text-base);
        --data-list-gap: var(--r5-space-1);
      }

      .lg {
        --data-list-label-size: var(--r5-text-sm);
        --data-list-value-size: var(--r5-text-lg);
        --data-list-gap: var(--r5-space-1-5);
      }

      /* Bordered variant */
      .bordered {
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-lg);
        padding: var(--r5-space-4);
      }

      /* Striped variant (vertical only) */
      .striped.vertical ::slotted(ark-data-list-item:nth-child(odd)) {
        background-color: var(--r5-bg-muted);
        margin: 0 calc(-1 * var(--r5-space-4));
        padding: var(--r5-space-3) var(--r5-space-4);
      }

      @media (max-width: 640px) {
        .grid.cols-3,
        .grid.cols-4 {
          grid-template-columns: repeat(2, 1fr);
        }
      }

      @media (max-width: 480px) {
        .grid.cols-2,
        .grid.cols-3,
        .grid.cols-4 {
          grid-template-columns: 1fr;
        }
      }
    `
];
d([
  a({ type: String, reflect: !0 })
], i.prototype, "orientation", 2);
d([
  a({ type: String, reflect: !0 })
], i.prototype, "size", 2);
d([
  a({ type: Number, reflect: !0 })
], i.prototype, "columns", 2);
d([
  a({ type: Boolean, reflect: !0 })
], i.prototype, "bordered", 2);
d([
  a({ type: Boolean, reflect: !0 })
], i.prototype, "striped", 2);
i = d([
  f("ark-data-list")
], i);
var w = Object.defineProperty, z = Object.getOwnPropertyDescriptor, n = (r, e, l, s) => {
  for (var t = s > 1 ? void 0 : s ? z(e, l) : e, p = r.length - 1, c; p >= 0; p--)
    (c = r[p]) && (t = (s ? c(e, l, t) : c(t)) || t);
  return s && t && w(e, l, t), t;
};
let o = class extends y {
  constructor() {
    super(...arguments), this.inline = !1, this.truncate = !1, this.mono = !1, this.copyable = !1, this.emptyText = "—";
  }
  async handleCopy() {
    if (!this.copyable) return;
    const r = this.value || this.textContent?.trim() || "";
    if (r)
      try {
        await navigator.clipboard.writeText(r);
      } catch (e) {
        console.error("Failed to copy:", e);
      }
  }
  render() {
    const r = !this.value && !this.querySelector(":not([slot])"), e = {
      item: !0,
      inline: this.inline,
      truncate: this.truncate,
      mono: this.mono,
      copyable: this.copyable,
      empty: r
    }, l = m`
      <svg class="copy-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/>
        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
      </svg>
    `;
    return m`
      <div
        part="item"
        class=${h(e)}
        @click=${this.handleCopy}
      >
        <dt part="label" class="label">
          <span class="icon"><slot name="icon"></slot></span>
          <slot name="label">${this.label}</slot>
        </dt>
        <dd part="value" class="value">
          ${this.value ?? m`<slot>${r ? this.emptyText : v}</slot>`}
          ${this.copyable ? l : v}
        </dd>
      </div>
    `;
  }
};
o.styles = [
  g,
  u`
      :host {
        display: block;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .item {
        display: flex;
        flex-direction: column;
        gap: var(--data-list-gap, var(--r5-space-1));
      }

      /* Inline layout (for horizontal parent) */
      .inline {
        flex-direction: row;
        align-items: baseline;
        gap: var(--r5-space-2);
      }

      .inline .label {
        flex-shrink: 0;
      }

      .inline .label::after {
        content: ':';
      }

      .label {
        display: flex;
        align-items: center;
        gap: var(--r5-space-1-5);
        font-size: var(--data-list-label-size, var(--r5-text-sm));
        font-weight: var(--r5-font-medium);
        color: var(--r5-text-muted);
        margin: 0;
      }

      .icon {
        display: flex;
        align-items: center;
        color: var(--r5-text-muted);
      }

      .icon ::slotted(*) {
        width: 1rem;
        height: 1rem;
      }

      .value {
        font-size: var(--data-list-value-size, var(--r5-text-base));
        font-weight: var(--r5-font-normal);
        color: var(--r5-text);
        margin: 0;
      }

      /* Truncate long values */
      .truncate .value {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      /* Monospace values */
      .mono .value {
        font-family: var(--r5-font-mono);
      }

      /* Copyable indicator */
      .copyable {
        cursor: pointer;
      }

      .copyable:hover .value {
        color: var(--r5-color-primary-600);
      }

      .copy-icon {
        display: none;
        width: 0.875rem;
        height: 0.875rem;
        margin-left: var(--r5-space-1);
        color: var(--r5-text-muted);
      }

      .copyable:hover .copy-icon {
        display: inline-flex;
      }

      /* Empty state */
      .empty .value {
        color: var(--r5-text-muted);
        font-style: italic;
      }
    `
];
n([
  a({ type: String })
], o.prototype, "label", 2);
n([
  a({ type: String })
], o.prototype, "value", 2);
n([
  a({ type: Boolean, reflect: !0 })
], o.prototype, "inline", 2);
n([
  a({ type: Boolean, reflect: !0 })
], o.prototype, "truncate", 2);
n([
  a({ type: Boolean, reflect: !0 })
], o.prototype, "mono", 2);
n([
  a({ type: Boolean, reflect: !0 })
], o.prototype, "copyable", 2);
n([
  a({ type: String, attribute: "empty-text" })
], o.prototype, "emptyText", 2);
o = n([
  f("ark-data-list-item")
], o);
export {
  i as A,
  o as a
};
//# sourceMappingURL=ark-data-list-item-Co0qiZ5M.js.map
